import React, { Component } from "react";
import styled from "styled-components";
import { hot } from "react-hot-loader/root";
import {
  colors,
  pageColors,
  boxedContainerStyleWithPadding,
  Headline2
} from "styles";

const AnnouncementContainer = styled.div`
  overflow: visible;
  margin-top: 75px;
`;

class Announcement extends Component {

  render() {
    return (
      <AnnouncementContainer>
        <Headline2>Introducing 15X5</Headline2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </p>
      </AnnouncementContainer>
    );
  }
}

export default hot(Announcement);
